module.exports = __webpack_public_path__ + "static/connection-9f6dd72e6fe528a92bb620700a6a2f58.png";